<div class="uk-card uk-card-default uk-margin-large-right uk-margin-medium-bottom" style="margin-top: 15px">
  <div class="uk-card-header uk-padding-small uk-background-muted">
    <div class="uk-width-expand">
      <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
        Consigne(s)
      </h3>
    </div>
  </div>
  <div class="uk-card-body uk-padding-remove">
    <kendo-grid [data]="listMenu">
      <ng-template kendoGridNoRecordsTemplate>
        Aucune consigne pour cette session
      </ng-template>
      <kendo-grid-column [width]="150" field="provenance" title="Provenance"> </kendo-grid-column>
      <kendo-grid-column field="consigne" title="Consigne(s)"> </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
